const lang_texts = {
  hu: {
    P:
      "Minden kérdést alaposan fontolj meg. Minden oldalon hét kérdést találsz, ha új oldalra navigáltál, vissza már nem tudsz lapozni.",
    NEXT: "Következő oldal",
  },
  en: {
    P:
    "EN: Minden kérdést alaposan fontolj meg. Minden oldalon hét kérdést találsz, ha új oldalra navigáltál, vissza már nem tudsz lapozni.",
    NEXT: "Next Page",
  },
};

const UrlParams = new URLSearchParams(window.location.search);
const lang = UrlParams.get("lang") || "hu";


function WelcomeScreen(props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        marginTop: 45,
      }}
    >
      <div className="questions" id="questions1">
        <div className="tContainer" id="textContainer">
          <p
            style={{
              fontSize: 20,
              color: "black",
              fontWeight: 500,
              marginTop: 42,
              textAlign: "center",
            }}
          >
           {lang_texts[lang].P} 
          </p>
        </div>
      </div>

      <div>
        <button
          className="button"
          onClick={(e) => {
            e.preventDefault();
            props.nextPage();
          }}
        >
         {lang_texts[lang].NEXT} 
        </button>
      </div>
    </div>
  );
}

export default WelcomeScreen;
